import { ContentLibrarySortBy } from '../contentsPage/interfaces'

import { Region } from './api'

export const contentKeys = {
  all: ['unified-flow'] as const,
  contents: () => [...contentKeys.all, 'contents'] as const,
  content: (id: string) => [...contentKeys.contents(), id] as const,
  variableCombinations: ({
    personalizationId,
    region,
    accountId,
  }: {
    personalizationId: string
    region: Region | undefined
    accountId: string
  }) =>
    [
      ...contentKeys.all,
      'variableCombinations',
      personalizationId,
      region,
      accountId,
    ] as const,
  templates: (accountId: string) =>
    [...contentKeys.all, 'template', accountId] as const,
  projectConfiguration: (
    projectId: string,
    isImageOptimizationEnabled?: boolean
  ) =>
    [
      ...contentKeys.all,
      'projectConfiguration',
      projectId,
      { isImageOptimizationEnabled },
    ] as const,
  campaigns: () => [...contentKeys.all, 'campaigns'] as const,
  campaign: (id: string) => [...contentKeys.campaigns(), id] as const,
  contentLibraryAll: () => [...contentKeys.all, 'contentLibrary'] as const,
  contentLibrary: ({
    accountId,
    offset,
    limit,
    sortBy,
    searchValue,
    selectedProjects,
    selectedOwners,
    selectedTypes,
    selectedTemplates,
    selectedStatuses,
  }: {
    accountId: string
    selectedProjects: string[]
    selectedOwners: string[]
    selectedTypes: string[]
    selectedTemplates: string[]
    selectedStatuses: string[]
    offset?: number
    limit?: number
    sortBy?: ContentLibrarySortBy
    searchValue: string
  }) =>
    [
      ...contentKeys.contentLibraryAll(),
      accountId,
      { offset, limit, sortBy, searchValue },
      {
        selectedProjects,
        selectedOwners,
        selectedTypes,
        selectedTemplates,
        selectedStatuses,
      },
    ] as const,
  brandVoices: (accountId: string) =>
    [...contentKeys.all, 'brandVoices', accountId] as const,
  regions: ({ userId }: { userId: string }) =>
    [...contentKeys.all, 'privacyRegions', userId] as const,
  teams: (accountId: string) =>
    [...contentKeys.all, 'teams', accountId] as const,
  productCatalogs: ({
    accountId,
    region,
  }: {
    accountId: string
    region: Region | undefined
  }) => [...contentKeys.all, 'productCatalogs', accountId, region] as const,
  profileAttributeCatalogs: ({
    accountId,
    region,
  }: {
    accountId: string
    region: Region | undefined
  }) =>
    [
      ...contentKeys.all,
      'profileAttributeCatalogs',
      accountId,
      region,
    ] as const,
  attributeCatalogTags: ({
    accountId,
    attributeCatalogId,
    region,
  }: {
    accountId: string
    attributeCatalogId: string
    region: Region | undefined
  }) =>
    [
      ...contentKeys.all,
      'attributeCatalogTags',
      accountId,
      attributeCatalogId,
      region,
    ] as const,
  customerJourneys: (accountId: string) =>
    [...contentKeys.all, 'customerJourneys', accountId] as const,
  experimentName: (
    accountId: string,
    projectId: string,
    experimentName: string
  ) =>
    [
      ...contentKeys.all,
      'experimentName',
      accountId,
      projectId,
      experimentName,
    ] as const,
  categoryProducts: ({
    accountId,
    catalogId,
    categoryId,
    region,
  }: {
    accountId: string
    catalogId: string | undefined
    categoryId: string | undefined
    region: Region | undefined
  }) =>
    [
      ...contentKeys.all,
      'categoryProducts',
      accountId,
      catalogId,
      categoryId,
      region,
    ] as const,
  categoryDetails: ({
    accountId,
    catalogId,
    categoryId,
    region,
  }: {
    accountId: string
    catalogId: string | undefined
    categoryId: string | undefined
    region: Region | undefined
  }) =>
    [
      ...contentKeys.all,
      'categoryDetails',
      accountId,
      catalogId,
      categoryId,
      region,
    ] as const,
}
